import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
export const StatusLabel = React.forwardRef(({ children, style, color, small = false, ...props }, ref) => (_jsx(Typography, { component: "div", sx: {
        ...style,
        ...(color ? { color } : undefined),
        textTransform: "uppercase",
        fontSize: small ? "12px" : "14px",
        fontWeight: 500,
    }, ref: ref, ...props, children: children })));
export default StatusLabel;
//# sourceMappingURL=StatusLabel.js.map